<template>
  <v-alert
    style="position: fixed; bottom: 20px; right: 20px; z-index: 999"
    v-if="alert?.show"
    :type="alert.type"
    :color="alert.color"
    dense
    transition="scale-transition"
    dismissible
    border="left"
    elevation="2"
    class="mb-4 rounded-lg transition-swing"
    @input="alert.show = false"
  >
    <div class="d-flex align-center">
      <div>
        <div class="font-weight-bold">{{ alert.title }}</div>
        <div>{{ alert.message }}</div>
      </div>
    </div>
  </v-alert>
</template>
<script lang="js">
export default {
  props:{
    alertProps:Object
  },
  data(){
    return{
      alert:null,
    }
  },
   watch:{
    alertProps:{
      handler(newValue){
        console.log(newValue)
        this.alert = newValue
      },
      deep:true
    }
   },
}
</script>
